module.exports = __webpack_public_path__ + "static/img/gamebanner1.3c0824d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/gamebanner1.png
// module id = Mlmw
// module chunks = 0